import { Form, Select } from "antd";

export default function Colour(props) {
  return (
    <Form.Item
      {...props}
      name="active"
      className="w-full"
      label="Status"
      rules={[
        {
          required: true,
          message: "Status is required",
        },
      ]}
    >
      <Select
        placeholder="Select one"
        className="w-full"
        options={[
          {
            label: "Published",
            value: true,
          },
          {
            label: "Draft",
            value: false,
          },
        ]}
      />
    </Form.Item>
  );
}
